'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _dec2, _class3;
// const { JSDOM } = jsdom;
// eslint-disable-next-line import/no-unresolved


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _draftJs = require('draft-js');

var _templateData = require('redux/modules/templateData');

var templateData = _interopRequireWildcard(_templateData);

var _saveUserData = require('redux/modules/saveUserData');

var _semanticUiReact = require('semantic-ui-react');

require('./MediaBlock.css');

var _reactSortableHoc = require('react-sortable-hoc');

var _components = require('components');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IMAGE_PLACEHOLDER = "https://live.staticflickr.com/8287/29517736620_3184b66ec8.jpg";
var EDIT_DRAFT_IMAGE = "EDIT_DRAFT_IMAGE";
var ADD_DRAFT_IMAGE = "ADD_DRAFT_IMAGE";
var DELETE_DRAFT_IMAGE = "DELETE_DRAFT_IMAGE";
var MOVE_RIGHT_DRAFT_IMAGE = "MOVE_RIGHT_DRAFT_IMAGE";
var MOVE_LEFT_DRAFT_IMAGE = "MOVE_LEFT_DRAFT_IMAGE";

var MediaBlock = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    image_edit_mode: state.templateData.image_edit_mode,
    design_template_name: state.templateData.design_template_name
  };
}, {
  updateInfo: templateData.updateField,
  saveUserData: _saveUserData.save
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(MediaBlock, _Component);

  function MediaBlock(props) {
    (0, _classCallCheck3.default)(this, MediaBlock);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MediaBlock.__proto__ || (0, _getPrototypeOf2.default)(MediaBlock)).call(this, props));

    _this.checkURL = function (url) {
      return url.match(/\.(jpeg|jpg|png)$/) != null;
    };

    _this.updateEditorContent = function (editor, entity, srcListNew) {
      var editorState = editor.state.editorState;
      var contentState = editorState.getCurrentContent();
      var newContentState = contentState.mergeEntityData(entity, { 'srcList': srcListNew });
      var editorStateWithEntity = _draftJs.EditorState.push(editorState, newContentState, 'edit-image');
      editor.updateEditorInfo(editorStateWithEntity);
      _this.handleFormBlur();
    };

    _this.handleImageEditClick = function (editor, entity, srcList, index) {
      var urlValue = window.prompt("Paste Image Link");
      if (urlValue !== null) {

        var srcListNew = srcList;
        srcListNew[index] = urlValue;

        _this.updateEditorContent(editor, entity, srcListNew);
      }
    };

    _this.handleImageAddClick = function (editor, entity, srcList, index) {
      var srcListNew = srcList;
      srcListNew.push(IMAGE_PLACEHOLDER);
      _this.updateEditorContent(editor, entity, srcListNew);
    };

    _this.handleImageDeleteClick = function (editor, entity, srcList, index) {
      var srcListNew = srcList;
      srcListNew.splice(index, 1);
      _this.updateEditorContent(editor, entity, srcListNew);
    };

    _this.createImageBlock = function (editor, srcList, entity) {

      var imageBlock = [];
      var style = {
        width: Math.round(100 / srcList.length).toFixed(4) + '%',
        padding: '20px'
      };

      srcList.map(function (src, index) {
        imageBlock.push(_react2.default.createElement(
          'div',
          { style: style, className: 'draftImageWrapper' },
          _react2.default.createElement('img', { style: { maxWidth: '100%' }, onError: _this.addDefaultSrc, src: src })
        ));
      });
      return imageBlock;
    };

    _this.handleFormBlur = function () {
      return _this.setState({ show_image_modal: false });
    };

    _this.showImageModal = function () {
      return _this.setState({ show_image_modal: true });
    };

    _this.state = {
      show_image_modal: false,
      srcList: false
    };
    return _this;
  }

  (0, _createClass3.default)(MediaBlock, [{
    key: 'addDefaultSrc',
    value: function addDefaultSrc(ev) {
      ev.target.src = IMAGE_PLACEHOLDER;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (this.props.block.getEntityAt(0) !== null) {
        var entity = this.props.contentState.getEntity(this.props.block.getEntityAt(0));

        var _entity$getData = entity.getData(),
            srcList = _entity$getData.srcList;

        var type = entity.getType();
        var _props$blockProps = this.props.blockProps,
            editor = _props$blockProps.editor,
            decoratedText = _props$blockProps.decoratedText;


        if (type === "image") {
          if (srcList) {
            return _react2.default.createElement(
              'div',
              { className: 'imageBlockWrapper', style: { display: '-webkit-box' } },
              _react2.default.createElement(_semanticUiReact.Icon, { className: 'imageEditIcon', name: 'edit', onClick: this.showImageModal }),
              this.createImageBlock(editor, srcList, this.props.block.getEntityAt(0)),
              this.state.show_image_modal && _react2.default.createElement(ImageModal, {
                onClose: this.handleFormBlur,
                srcList: srcList,
                saveImageChanges: function saveImageChanges(items) {
                  return _this2.updateEditorContent(editor, _this2.props.block.getEntityAt(0), items);
                }
              })
            );
          } else {
            return null;
          }
        } else {
          return _react2.default.createElement('span', null);
        }
      } else {
        return _react2.default.createElement(
          'span',
          null,
          'Please insert the image(s) again'
        );
      }
    }
  }]);
  return MediaBlock;
}(_react.Component)) || _class);
exports.default = MediaBlock;
var ImageModal = (_dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    uploaded_image_url: state.templateData.uploaded_image_url,
    uploaded_image_index: state.templateData.uploaded_image_index
  };
}, {
  updateInfo: templateData.updateField,
  saveUserData: _saveUserData.save,
  uploadImage: templateData.uploadImage
}), _dec2(_class3 = function (_Component2) {
  (0, _inherits3.default)(ImageModal, _Component2);

  function ImageModal(props) {
    (0, _classCallCheck3.default)(this, ImageModal);

    var _this3 = (0, _possibleConstructorReturn3.default)(this, (ImageModal.__proto__ || (0, _getPrototypeOf2.default)(ImageModal)).call(this, props));

    _this3.onSortEnd = function (_ref) {
      var oldIndex = _ref.oldIndex,
          newIndex = _ref.newIndex;

      _this3.setState(function (_ref2) {
        var items = _ref2.items;
        return {
          items: (0, _reactSortableHoc.arrayMove)(items, oldIndex, newIndex)
        };
      });
    };

    _this3.saveChanges = function (items) {
      _this3.props.saveImageChanges(items);
    };

    _this3.handleDeleteImage = function (index) {
      var items = _this3.state.items;

      items.splice(index, 1);
      _this3.setState({ items: items });
    };

    _this3.handleAddImage = function (index) {
      var items = _this3.state.items;

      if (index == items.length) {
        items.push(IMAGE_PLACEHOLDER);
      } else {
        items.splice(index + 1, 0, IMAGE_PLACEHOLDER);
      }
      _this3.setState({ items: items });
    };

    _this3.handleUpload = function (data) {
      _this3.props.uploadImage(data);
    };

    _this3.state = {
      items: _this3.props.srcList
    };
    return _this3;
  }

  (0, _createClass3.default)(ImageModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.uploaded_image_url != nextProps.uploaded_image_url && nextProps.uploaded_image_url != false) {
        console.log(nextProps.uploaded_image_url);
        var items = this.state.items;

        items[nextProps.uploaded_image_index] = nextProps.uploaded_image_url;
        this.setState({ items: items });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        { centered: true, closeIcon: true, open: true, onClose: this.props.onClose },
        _react2.default.createElement(
          _semanticUiReact.Modal.Header,
          null,
          'Image Editor'
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(SortableList, {
            axis: 'x',
            lockAxis: 'x',
            deleteImage: this.handleDeleteImage.bind(this),
            addImage: this.handleAddImage.bind(this),
            items: this.state.items,
            onSortEnd: this.onSortEnd,
            helperClass: 'sortableHelper',
            useDragHandle: true,
            handleUpload: this.handleUpload
          })
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(_semanticUiReact.Button, {
            positive: true,
            icon: 'checkmark',
            labelPosition: 'right',
            content: 'Confirm',
            onClick: function onClick(e) {
              return _this4.saveChanges(_this4.state.items);
            } })
        )
      );
    }
  }]);
  return ImageModal;
}(_react.Component)) || _class3);


var SortableList = (0, _reactSortableHoc.SortableContainer)(function (_ref3) {
  var items = _ref3.items,
      deleteImage = _ref3.deleteImage,
      addImage = _ref3.addImage,
      handleUpload = _ref3.handleUpload;

  return _react2.default.createElement(
    _semanticUiReact.Form,
    null,
    _react2.default.createElement(
      _semanticUiReact.Form.Group,
      null,
      items.map(function (value, index) {
        return _react2.default.createElement(SortableItem, {
          key: 'item-' + index,
          deleteImage: deleteImage,
          addImage: addImage,
          index: index,
          iValue: index,
          value: value,
          handleUpload: handleUpload
        });
      })
    )
  );
});

var SortableItem = (0, _reactSortableHoc.SortableElement)(function (_ref4) {
  var value = _ref4.value,
      index = _ref4.index,
      iValue = _ref4.iValue,
      deleteImage = _ref4.deleteImage,
      addImage = _ref4.addImage,
      handleUpload = _ref4.handleUpload;

  return _react2.default.createElement(
    'div',
    { className: 'sortableHelper', style: { margin: '10px' } },
    _react2.default.createElement(
      'div',
      { style: { display: 'flex', textAlign: 'justify', justifyContent: 'space-between', paddingBottom: '10px' } },
      _react2.default.createElement(DragHandle, null),
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'trash',
        style: { color: 'black', cursor: 'pointer' },
        className: 'imageDeleteHandle',
        onClick: function onClick(e) {
          return deleteImage(iValue);
        }
      }),
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'plus',
        style: { color: 'black', cursor: 'pointer' },
        className: 'imageEditHandle',
        onClick: function onClick(e) {
          return addImage(iValue);
        }
      })
    ),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_components.ImageRenderer, { src: value, imageIndex: iValue, handleUpload: handleUpload })
    )
  );
});

var DragHandle = new _reactSortableHoc.SortableHandle(function () {
  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'move', style: { color: 'black', cursor: 'grab' }, className: 'imageDragHandle' });
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MediaBlock/MediaBlock.js
// module id = 1739
// module chunks = 0